export enum EAssetsTabs {
  DETAILS = 0,
  TAGS = 1,
  PROPERTIES = 2,
  ALARMS = 3,
  SUBSCRIPTIONS = 4,
  PERMISSIONS = 5,
  VISIBILITY = 6,
  LINK = 7
}

export enum EComponentTabs {
  DETAILS = 0,
  TAGS = 1,
  PROPERTIES = 2,
  ALARMS = 3,
  PERMISSIONS = 5,
  AGGREGATIONS = 5,
  PANELS = 6,
  CREATE_PANEL = 7
}

export enum EModelTabs {
  DETAILS = 0,
  TAGS = 1,
  PROPERTIES = 2,
  ALARMS = 3,
  RELATIONSHIPS = 4,
  PERMISSIONS = 5,
  AGGREGATIONS = 6,
  PANELS = 7,
  DASHBOARD = 8,
  CREATE_PANEL = 9
}

export enum EGroupTabs {
  PANELS = 0,
  DASHBOARD = 1,
  CREATE_PANEL = 2,
}

export enum EModelDashboardTabs {
  VIEW_DASHBOARD = 0,
  SELECT_PANELS = 1,
  DASHBOARDS_Grid = 2,
}

export enum ETreeLevel {
  Group = 1,
  Node = 2,
}

export enum EUserGroupTabs {
  Group = 0,
  Role = 1,
  User = 2,
  AssetsPermissions = 3
}

export enum EMainChartTypes {
  line = 1,
  Area = 2,
  Bar = 3,
  Gauge = 4,
  Heat = 5,
  Dynamic = 6,
  Pie = 7,
  Bubble_Scatter = 8,
  Metric = 9,
  Polar = 10,
  Tables = 11,
  Maps = 12
}

export enum EChartTypes {
  Sparkline = 2,
  Basic_Bar = 1,
  Basic_Line = 3,
  Ajax_Loaded_Data = 4,
  Points_500k = 5,
  Spline_with_Inverted_Axis = 6,
  Spline_with_Plot_Bands = 7,
  Time_Series_Zoomable = 8,
  With_Annotations = 9,
  Activity_Guage = 10,
  Bullet_Graph = 11,
  Speedometer = 12,
  Speedometer_with_Dual_Axis = 13,
  Solid_Guage = 14,
  VU_Meter = 15,
  Heat_Map = 16,
  Large_Heat_Map = 17,
  Master_Detail_Chart = 18,
  Pie_Chart = 19,
  Bubble_Chart = 20,
  Scatter_Chart = 21,
  Stat = 22, // metric
  Polar = 23,
  Tag_Table = 24,
  Asset_Table = 25,
  Group_Table = 26,
  Property_Table = 27,
  Maps = 28,
  Command_Table = 29,
}

export enum EChartTheme {
  Brand_Light = 'brand light',
  Brand_Dark = 'brand dark',
  Dark_Unica = 'dark Unica',
  Sand_Signica = 'sand signica',
  Grid_Light = 'grid light'
}

export enum EEntityTypes {
  COMPONENTS = 'components',
  MODELS = 'models',
  ASSETS = 'assets',
  DASHBOARD = 'dashboard',
  User_Dashboard = '/dashboard',
  PERSPECTIVES = 'perspectives',
  USERGROUPS = 'user-management/usergroups',
  ALARMS = 'alarms',
  USER_ALARMS = 'user-alarms',
}

export enum ERanges {
  H1 = 1,
  H6 = 2,
  H12 = 3,
  D1 = 4,
  W1 = 5,
  M1 = 6,
  M3 = 7
}

export enum EESPSplineChartNames {
  MULTI_FREQUENCY_PUMP_PERFORMANCE_EFFICIENCY_CURVE = 'Multi-Frequency Pump Performance Efficiency Curve',
  MULTI_FREQUENCY_PERFORMANCE_POWER_CAPACITY_CURVE = 'Multi-Frequency Performance Power-Capacity Curve',
  DYNAMIC_OPERATING_POINT = 'Dynamic Operating Point',
  TEMPERATURE_PROFILE = 'Temprature Profile',
  PRESSURE_PROFILE = 'Pressure Profile',
  MULTI_FREQUENCY_HEAD_CAPACITY_CURVE = 'Multi-Frequency Head-Capacity Curve',
  Pump_performance_Curve_and_Well_performance_Complete_Pump_Corrected_by_Viscostly = 'Pump performance Curve and Well performance-Complete Pump-Corrected by Viscostly',
  Pump_Performance_curve_For_one_Stage_Corrected_by_Viscosity = 'Pump Performance curve For one Stage-Corrected by Viscosity'
}

export enum EGLSplineChartNames {
  DYNAMIC_OPERATION_ENVELOPE = 'Dynamic Operation Envelope',
  DYNAMIC_PRESSURE_PROFILE = 'Dynamic Pressure Profile',
  DYNAMIC_TEMPERATURE_PROFILE = 'Dynamic Temperature Profile',
  GAS_LIFT_PERFORMANCE_CURVE = 'Gas Lift Performance Curve',
  HYDRATE_CURVES = 'Hydrate Curves',
  SENSITIVITY_ANALYSIS = 'Sensitivity Analysis',
  WPR_CPR = 'WPR-CPR',
  DESIGN_CURVE_DATA = 'Design Curve Data'
}

export enum ESRPSplineChartNames {
  DYNA_CARDS = 'Dyna Cards',
  OPERATING_TREND = 'Operating Trend',
  PERMISSIBLE_LOADS = 'Permissible Loads',
  SURFACE_AND_DOWNHOLE_CARDS = 'Surface and Downhole Cards',
  SURFACE_CARD_LOAD = 'Surface Card Load',
  TEMPERATURE_GRADIENT_OPERATING_POINT = 'Temperature Gradient Operating Point',
  TORQUE = 'Torque',
  VERTICAL_GRADIENT = 'Vertical Gradient',
}

export enum EAggregationTypes {
  GROUP_AGGR = 'GROUP_AGG',
  PIPELINE_AGG = 'PIPELINE_AGG',
  TIME_AGG = 'TIME_AGG'
}

export enum EAssetTableTypes {
  TAG = 'Tag',
  PROPERTY = 'Property'
}

export enum ETagPropertyDataType {
  All = 'All',
  Number = 'Number',
  Calculated = 'Calculated',
  Text = 'Text',
  State = 'State',
  String = 'String',
  Datetime = 'Datetime',
  UnixEpochTimestamp = 'Unix Epoch Timestamp',
  CoordinatesDD = 'Coordinates DD',
  Aggregated = 'Aggregated',
  Boolean = 'Boolean'
}

export enum ERefPanelNames {
  EntityPanel = '7b7ac4a2-ec06-4816-955c-4b59b10ea6e1',
  AggrPanel = '3d2cc678-d6b6-40f1-a6b4-39564db50afc',
  PerspectivePanel = '88f71dcc-0603-425f-9df0-7949cc5987be'
}

export enum EPropertyTypes {
  Text = '3b60c4b3-3ca4-404d-8b7d-4cca6039adc9',
  Datetime = '31c9386f-e793-4ff0-9e20-31f947c6b2db',
  CoordinatesDD = 'b1a596e0-e5bb-4e8a-b97c-9bbee3810fae'
}

export enum ESelectorType {
  AssetTable = 'asset-table',
  Aggregation = 'aggregation',
  GroupAggregation = 'group-aggregation'
}

export enum EFunctionTypes {
  MIN = 1,
  MAX = 2,
  AVG = 3,
  MEDIA = 4,
  MODE = 5,
  SUM = 6,
  COUNT = 7,
  RANGE = 8
}

export enum EUserTabs {
  User = 0,
  Member = 1,
}

export enum EMembersPages {
  UserPage = 'userPage',
  UserGroupPage = 'userGroupPage',
}

export enum EUserGroupTabs {
  Details = 0,
  Roles = 1,
  Users = 2
}

export enum EConnectNulls {
  Never = 1,
  Always = 2
}

export enum EMapPanelTypes {
  PROPERTY = 'Property'
}


export enum EAggregationsTabs { Aggregations = 0, Aggregation = 1 }

export enum EAclTypes { Read = 'read', Write = 'write', Delete = 'delete' }

export enum EViewTypes { ADMIN = 'admin', DASHBOARD = 'dashboard' }

export enum ECommandFields { Writeback = 1, Dropdown = 2, Button = 3, Value = 4 }

export enum EPanelSettingsTabs { Details = 0, Configuration = 1 }

export enum EFeatureTreeRoots { Configuration = '1', Applications = '2', Common = '3' }

export enum EAssetEvents { Alarm = "alarm", Writeback = "writeback", DsNodeUnlinked = "dsnode-unlinked", tagUnlinked = "tag-unlinked" }

export enum EReturnTypes { Numeric = 'Numeric', String = 'String' }

export enum ECalTagsItemsTypes { Tag = "(T)", Property = "(P)", Aggregation = "(A)" }

export enum ERefreshRate { Off = 'Off', S10 = '10s', S30 = '30s', M1 = '1m', M5 = '5m', M10 = '10m', M15 = '15m' }

export enum ERefTypes { ComponentType = 'Component Type', ModelType = 'Model Type', Vendor = 'Vendor', Group = 'Group' }

export enum EDropdownTypes { ComponentType = 'Component Type', ModelType = 'Model Type', Vendor = 'Vendor', SP_Group = 'Sparkplug Group', DS_Unlink_Reason = 'DS Unlink Reason', Tag_Unlink_Reason = 'Tag Unlink Reason' }

export enum ERefreshAlarm { RefreshAlarm = 'refresh-alarm' }

export enum ETextAlignment { auto = 'Auto', center = 'Center' }

export enum EMetricStyles { auto = 'Auto', value_n_name = 'Tag Value and Name', name = 'Tag Name', value = 'Tag Value' }

export enum EThresholdModes { absolute = 'Absolute', percentage = 'Percentage' }

export enum ETextLayout { horizontal = 'Horizontal', vertical = 'Vertical' }

export enum EStatGraphModes { none = 'None', area = 'Area' }

export enum EUnits { Meters = 'Meters', Feets = 'Feets', Celsius = 'Celsius', Number = 'Number', Percent = 'Percent', Pixels = 'Pixels', Square_Feet = 'Square Feet' }

export enum EThresholdColors { White = '#fff', Green = '#73BF69', Blue = '#2889e9', Pink = '#e920e9', Yellow = '#fff500', Red = '#EC4040' }

export enum EAnnotationToolTipModes { Single = 'Single', All = 'All', Hidden = 'Hidden' }

export enum EAnnotationToolTipValueSorts { None = 'None', Ascending = 'Ascending', Descending = 'Descending' }

export enum ELegendAlignments { Bottom = 'Bottom', Right = 'Right' }

export enum EAnnotationXaxisPlacements { Bottom = 'Bottom', Top = 'Top', Hidden = 'Hidden' }

export enum EAnnotationXaxisShowGridLines { On = 'On', Off = 'Off' }

export enum EAnnotationYaxisPlacements { Left = 'Left', Right = 'Right', Hidden = 'Hidden' }

export enum EAnnotationYaxisShowGridLines { On = 'On', Off = 'Off' }

export enum EAnnotationGSstyles { Lines = 'Lines', Points = 'Points' }

export enum EAnnotationGSConnectsNulls { Never = 'Never', Always = 'Always', Threshold = 'Threshold' }

export enum EAnnotationGSshowpoints { Always = 'Always', Never = 'Never' }

export enum ECommandFieldsOptions { Writeback = 'Writeback', Dropdown = 'Dropdown', Button = 'Button', Value = 'Value' }

export enum ETagsTableCellHeights { Small = 'Small', Medium = 'Medium', Large = 'Large' }

export enum ETagsTableColAlignments { Left = 'Left', Center = 'Center', Right = 'Right' }

export enum EAnnotationThresholdList { off = 'Off', line = 'Solid', Dash = 'Dash', DashDotDot = 'LongDashDotDot' }

export enum EBreadCrumbNames { Components = 'Components', Models = 'Models', Assets = 'Assets', Perspectives = 'Perspectives' , Users = 'Users' , UserGroups = 'User Groups',Roles = 'Roles', Sparkplug = 'Sparkplug' }

export enum EEntityCharts { AssetTable = 25, GroupTable = 26, Stat = 22, Map = 28, TagTable = 24, PropertiesTable = 27, CommandTable = 29, Annotation = 9, Polar = 23, SolidGuage = 14 }

export enum EUserManagmentTabs { Users = 'users', Roles = 'roles', UserGroups = 'usergroups' }
